import { Paper, Typography, Box, Divider, Link } from "@mui/material";
import FileUploadInput from "./FileUploadInput";

const AuthorizationINSSSection = ({
  fields,
  files,
  existingFiles = [],
  onFileChange,
}) => {
  const filesByKey = (key) =>
    existingFiles.filter((f) => f.name.startsWith(key));

  const buildFileUrl = (filename) =>
    `${process.env.REACT_APP_BACKEND_HOST}/storage/caseconfig/inss_authorization.pdf`;

  return (
    <Paper variant="outlined" sx={{ p: 3 }}>
      <Typography variant="h6" fontWeight="bold">
        Autorización INSS
      </Typography>

      <Divider sx={{ my: 2 }} />

      {fields.map(({ key, title }) => {
        const relatedFiles = filesByKey(key);

        return (
          <Box key={key} sx={{ mb: 3 }}>
            {/* Fila principal */}
            <Box
              sx={{
                display: "flex",
                alignItems: "center",
                justifyContent: "space-between",
              }}>
              <Typography>{title}</Typography>

              <FileUploadInput
                file={files[key]}
                onChange={(file) => onFileChange(key, file)}
              />
            </Box>

            {/* Lista de archivos existentes */}
            {relatedFiles.length > 0 && (
              <Box sx={{ mt: 1, pl: 2 }}>
                <Typography variant="caption" color="text.secondary">
                  Archivos existentes:
                </Typography>

                {relatedFiles.map((file) => (
                  <Typography key={file.name} variant="body2" sx={{ mt: 0.5 }}>
                    •{" "}
                    <Link
                      href={buildFileUrl(file.name)}
                      target="_blank"
                      rel="noopener noreferrer"
                      underline="hover">
                      {file.name}
                    </Link>
                  </Typography>
                ))}
              </Box>
            )}
          </Box>
        );
      })}
    </Paper>
  );
};

export default AuthorizationINSSSection;
